import React, { Component } from 'react';
import classNames from 'classnames';
import closeIcon from '../../../assets/icons/icon_close.svg';

class ScenarioDropdown extends Component{
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      infoActive: false,
      dropdownActive: false
    }
  }

  handleInfoModal = () => {
    const infoModal = this.refs.infoModal;
    const activeState = this.state.infoActive;
    const section = this.refs.section;
    if (infoModal !== undefined && section !== undefined){
      if(activeState){
        infoModal.classList.remove(this.props.styles.infoModalActive)
        section.classList.remove(this.props.styles.containerRotate)
        this.setState({
          infoActive: false
        })
      }
      else{
        infoModal.classList.add(this.props.styles.infoModalActive)
        section.classList.add(this.props.styles.containerRotate)
        this.setState({
          infoActive: true,
          dropdownActive: false
        })
      }
    }
  }

  getScenarioById(eId){
    const selectedId = parseInt(eId, 16);
    return this.props.data.filter(item => item.id === selectedId)[0]
  }

  handleChange(e) {
    const selectedScenario = this.getScenarioById(e);
    this.props.onChange(selectedScenario);
    this.setState({
      dropdownActive: false
    })
  }

  toggleDropdown = () => {
    var activeBool = this.state.dropdownActive ? false : true;
    this.setState({
      dropdownActive: activeBool
    })
  }

  componentWillMount() {
    // set up first item in the list
    this.props.onChange(this.props.data[0])
  }

  render() {
    const styles = this.props.styles;
    const data = this.props.data;
    const selectedItem = this.props.selected;
    const activeDropdownStyle = this.state.dropdownActive ? styles.dropdownChoicesActive : null;
    const listOptions = data.map((scenario) => {
      const activeClass = scenario.id === selectedItem.id ? styles.dropdownChoiceActive : null;
      return(
        <li key={scenario.id} className={activeClass} onClick={() => this.handleChange(scenario.id)}>{scenario.short_name}</li>
      );
    })
    return(
      <div ref="section" className={styles.inputItem}>
        <div className={styles.info}>
          {this.props.helpText &&
            <div>
              <img src={this.props.icon} alt="Info" onMouseDown={this.handleInfoModal} />
              <div className={styles.infoModal} ref="infoModal" onMouseDown={this.handleInfoModal}>
                <h5>{this.props.description}</h5>
                <p>{this.props.helpText}</p>
                <img src={closeIcon} alt="Info" onMouseDown={this.handleInfoModal} />
              </div>
            </div>
          }
        </div>
        <div className={styles.dropdownContainer}>
          <button className={styles.dropdownButton} onClick={() => this.toggleDropdown()}>{selectedItem.short_name}</button>
          <ul className={classNames([styles.dropdownChoices, activeDropdownStyle])}>
            {listOptions}
          </ul>
        </div>
        <span>{this.props.unitInfo}</span>
        <span className={styles.bottom}>
          {this.props.description}
        </span>
      </div>
    );
  }
}

export default ScenarioDropdown;



// WEBPACK FOOTER //
// ./src/components/calculator/inputs/c_scenario_dropdown.js